import { useNavigate } from "react-router-dom";
import { Crosshair, History, Play, Siren, Hexagon, PhoneCall } from "lucide-react";
import { cn } from "@/lib/utils";

export function QuickActions({ vehicleId, onLocate, className, compact, simNumber }) {
  const nav = useNavigate();
  const dialNumber = String(simNumber || "").replace(/[^0-9+]/g, "");
  const items = [
    ["locate", "Locate", Crosshair, () => (onLocate ? onLocate() : nav(`/live?v=${vehicleId}`))],
    ["history", "History", History, () => nav(`/history?v=${vehicleId}`)],
    ["playback", "Playback", Play, () => nav(`/playback?v=${vehicleId}`)],
    ["geofence", "Geofence", Hexagon, () => nav(`/geofence?v=${vehicleId}`)],
    ["alarm", "Alarm", Siren, () => nav(`/alarms?v=${vehicleId}`)],
    ...(dialNumber ? [["call-device", "Panggil SIM GPS", PhoneCall, () => {
      window.location.href = `tel:${dialNumber}`;
    }]] : []),
  ];
  return (
    <div className={cn(`grid ${simNumber ? "grid-cols-3 sm:grid-cols-6" : "grid-cols-5"} gap-2`, className)} data-testid="quick-actions">
      {items.map(([k, label, Icon, fn]) => (
        <button key={k} onClick={fn} data-testid={`quick-action-${k}`}
          className="group flex flex-col items-center gap-1.5 rounded-xl border border-border bg-background/40 px-1 py-2.5 transition-[border-color,transform] duration-150 hover:-translate-y-0.5 hover:border-primary/60 active:scale-95">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent text-foreground transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
            <Icon className="h-4 w-4" />
          </span>
          {!compact && <span className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">{label}</span>}
        </button>
      ))}
    </div>
  );
}
